export default {
  title: 'Lataa {{app}}-sovellus',
  qr_code_desc: 'Skannaa tämä QR-koodi puhelimellasi ladataksesi sovelluksen',
  cta: 'Lataa sovellus ja kirjaudu sisään saadaksesi {{amount}} käteispalautusta!',
  download_from: 'Tai lataa täältä:',
  direct_link: 'Suora linkki:',
};
